export enum ApplicationType {
  Unset = "Unset",
  Main = "Main",
  Admin = "Admin",
  Landings = "Landings",
}
